import React from 'react'
import Link from 'gatsby-link'
import slugify from 'slugify'
import {slugifyOptions} from '../../config'

import BreadCrumbs from '../BreadCrumbs/breadcrumbs'

import ClockIcon from '../../assets/icons/clock-icon'


import './news.scss'

class NewsPage extends React.Component {
  constructor(props) {
    super(props)
  }

  renderImage(image) {
    if (image) {
      const { src, srcSet, title } = image.sizes
      return (        
        <img src={ src } srcSet={ srcSet } className="feature-image" alt={ title } />
      )
    }

    return null
  }

  renderArticle(article) {
    const image = this.renderImage(article.featureImage) 
    const backgroundColor = article.backgroundColor || 'white'
    const linkClass = image ? '' : 'no-image'

    return (
      <div style={ { backgroundColor }} className="article-container" key={ article.id }>
        <Link to={`/${this.props.lang}/article/${slugify(article.heading, slugifyOptions)}`} className={ `unstyled article-link ${linkClass}` }>
          <div className="image-container">
            { image }
          </div>

          <div className="article-content">
            <div className="content-wrapper">
              <div className="date">
                <ClockIcon className="icon" /> <time className="created-at">{ article.createdAt }</time>
              </div>
              <h5>{ article.heading }</h5> 
            </div>
          </div>
        </Link>
      </div>
    )
  }

  render() {
    const news = this.props.content
    const { lang, localization } = this.props

    return (
      <div>
        <BreadCrumbs lang={ lang } localization={ localization} />
        <div className="news-list-container news-page-container">
          {/*<div className="standard-container news-container news-page-container" data-cy="faq-page-search">*/}
          <div className="news-container" data-cy="faq-page-search">
            { news.map(article => this.renderArticle(article.node)) }
          </div>
        </div>
      </div>
      
    )
  }
}

export default NewsPage



// WEBPACK FOOTER //
// ./src/components/News/news-page.js